module.exports = __webpack_public_path__ + "static/media/journey_sl_results.2e945e57.png";